/**
 * Canonical involuntary-change notification kind — the semantic `notificationType`
 * the Phase 3 agent (`flight_schedule_change`) EMITS and the Phase 4 channel
 * (`whatsapp-integration`) RESOLVES to a concrete Meta template via the
 * `notification_templates` registry. A wire-crossing enum, so it lives in
 * `packages/domain`, not as an agent-local type.
 *
 * The agent's existing local `NotifyType` union in
 * `apps/services/agents/src/agents/flight_schedule_change/threshold.ts` will be
 * migrated to import this canonical enum in Phase 3 (Decision A); Phase 1 only
 * exports it.
 *
 * This is a cross-service wire contract, NOT a persisted Mongo document, so it
 * carries no `_schemaVersion`.
 */
import { z } from 'zod';

export const NotifyTypeSchema = z.enum(['advanced', 'delayed', 'cancelled', 'rerouted', 'skip']);
export type NotifyType = z.infer<typeof NotifyTypeSchema>;
